import api from '@pray/shared/utils/api';

import type { WarmupSendingOption } from './types';

export async function getWarmupSendingOptions({ artistId }: { artistId: string }): Promise<WarmupSendingOption[]> {
  if (!artistId) throw new Error('Artist ID is required');
  const url = `/web/studio/artists/${artistId}/warmup-campaigns/sending-options`;
  const response = await api.executeGetRequest<{ data: { senders: WarmupSendingOption[] } }>(url);
  return response.data.data.senders;
}
